import { render, staticRenderFns } from "./upload-config.vue?vue&type=template&id=f58882f2&scoped=true"
import script from "./upload-config.vue?vue&type=script&lang=js"
export * from "./upload-config.vue?vue&type=script&lang=js"
import style0 from "./upload-config.vue?vue&type=style&index=0&id=f58882f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58882f2",
  null
  
)

export default component.exports